/** Exact identity in a saved result. Labels and layout are not identities. */
export type WorkDocumentOutput = { tabId: string; sectionId: string };

/** Undefined = legacy/no selection; null = an explicitly invalid selection. */
export const readDocumentOutput = (params: URLSearchParams): WorkDocumentOutput | null | undefined => {
  if (!params.has('outputTab') && !params.has('outputSection')) return undefined;
  const tabId = params.get('outputTab');
  const sectionId = params.get('outputSection');
  return tabId && sectionId && tabId.length <= 255 && sectionId.length <= 255
    ? { tabId, sectionId } : null;
};

export const setDocumentOutput = (params: URLSearchParams, output?: WorkDocumentOutput): void => {
  params.delete('outputTab'); params.delete('outputSection');
  if (output) { params.set('outputTab', output.tabId); params.set('outputSection', output.sectionId); }
};
